import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Range} from '../../../../shared/model/range-model';
import {NavigationSidePanelItem} from "../../../../layout/navigation-side-panel/navigation-side-panel.component";


@Component({
  standalone: false,
  selector: 'app-odm-manage-options',
  templateUrl: './odm-manage-options.component.html',
  styleUrls: ['./odm-manage-options.component.scss']
})
export class OdmManageOptionsComponent implements OnInit {
  @Input()
  selectedRange: Range;

  @Output()
  clickBack: EventEmitter<void> = new EventEmitter<void>();


  tabs: NavigationSidePanelItem[] = [
    {id: 1, title: 'T_NAV_ADMIN_OFFER_DATA_MANAGEMENT_LIST_OPTIONS_ELEMENT', active: true},
    {id: 2, title: 'T_NAV_ADMIN_OFFER_DATA_MANAGEMENT_LIST_OPTIONS_COMPONENT'}
  ]

  constructor() {
  }

  ngOnInit(): void {
  }

  getTabs() {
    return this.tabs;
  }

  selectTab(tab: NavigationSidePanelItem) {
    this.tabs = this.tabs.map((t) => {
      t.active = t.id === tab.id;
      return t;
    });
  }

  isTabActive(id: number) {
    return this.tabs.find((tab) => {
      return tab.id === id
    }).active;
  }

  returnOnOfferSelection() {
    this.clickBack.emit();
  }

}
